import {COLOR_RED, generateUniqueId, levelData, creatureTypes, creatureSizes, alignmentOptions } from '../constants';

function removeHTMLTags(str) {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
}

function normalizeWhitespace(str) {
  return str.replace(/\s+/g, ' ').trim();
}

// optional: also normalize punctuation spacing so ",  " or " ; " become ", "
function normalizeAndTidyPunctuation(str) {
  return str
    .replace(/\s+/g, ' ')              // collapse whitespace/newlines
    .replace(/\s*([,;:])\s*/g, '$1 ')  // one space after punctuation
    .trim();
}

const getStats = (creature, profBonus) => {

    if(creature.isReleased) {
        const STR = creature.stats[0].value
        const DEX = creature.stats[1].value
        const CON = creature.stats[2].value
        const INT = creature.stats[3].value
        const WIS = creature.stats[4].value
        const CHA = creature.stats[5].value
    
        const STR_MOD = Math.floor((STR-10)/2)
        const DEX_MOD = Math.floor((DEX-10)/2)
        const CON_MOD = Math.floor((CON-10)/2)
        const INT_MOD = Math.floor((INT-10)/2)
        const WIS_MOD = Math.floor((WIS-10)/2)
        const CHA_MOD = Math.floor((CHA-10)/2)
    
        let saves = creature.savingThrows
        return {
            "strength": STR,
            "dexterity": DEX,
            "constitution": CON,
            "intelligence": INT,
            "wisdom": WIS,
            "charisma": CHA,
            "strength_save": saves.some(save => save.statId === 1) ? profBonus + STR_MOD : 0,
            "dexterity_save": saves.some(save => save.statId === 2) ? profBonus + DEX_MOD : 0,
            "constitution_save": saves.some(save => save.statId === 3) ? profBonus + CON_MOD : 0,
            "intelligence_save": saves.some(save => save.statId === 4) ? profBonus + INT_MOD : 0,
            "wisdom_save": saves.some(save => save.statId === 5) ? profBonus + WIS_MOD : 0,
            "charisma_save": saves.some(save => save.statId === 6) ? profBonus + CHA_MOD : 0,
        }
    } else {
        return {
            "strength": 10,
            "dexterity": 10,
            "constitution": 10,
            "intelligence": 10,
            "wisdom": 10,
            "charisma": 10,
            "strength_save": 0,
            "dexterity_save": 0,
            "constitution_save": 0,
            "intelligence_save": 0,
            "wisdom_save": 0,
            "charisma_save": 0,
        }
    }
}


const calcSpeed = (speedJson) => {
    if(!speedJson) {
        return {'walk': 0}
    }
    let speedReturn = {}
    // This is "50 ft., fly 150 ft." - split into array
    let speedArr = speedJson.value.split(",");
    console.log("speedArr", speedArr)
    speedArr.forEach(s => {
        s = s.replaceAll(' ft.', '').trim();
        let speedSplit = s.split(" ")
        console.log("speedSplit", speedSplit)
        // Walk speed will not have the 'walk' label
        let type = 'walk';
        let value;
        if(speedSplit.length === 1) {
            value = speedSplit[0].trim()
        } else {
            type = speedSplit[0].trim()
            value = speedSplit[1].trim()
        }
        
        let typesOfSpeed = ['walk', 'burrow', 'climb', 'fly', 'swim']
        // return -1 if not found, check if 0 because that is falsey
        let index = typesOfSpeed.indexOf(type)
        if(index > -1) {
            speedReturn[typesOfSpeed[index]] = value
        }
    })


    // TODO HOVER
    // TODO Currently strings, might need to be ints
    // if(speed?.canHover) {
    //     speed.hover = speed.canHover
    // }

    return speedReturn;
}

function findOptions(typeInfo, options) {
    let type = '';
    Object.values(options).forEach(ct => {
        if(typeInfo.includes(ct)) {
            type = ct
        }
    })

    // TODO return null?
    return type
}

function getAttr(monsterHtml, selector, attr) {
    const el = monsterHtml.querySelector(selector);
    return el ? el.getAttribute(attr) : '';
}

function getAttrJson(monsterHtml, labelText) {
    // Find all attribute blocks
    const blocks = monsterHtml.querySelectorAll('.mon-stat-block__attribute');
    for (let block of blocks) {
        const labelEl = block.querySelector('.mon-stat-block__attribute-label');
        if (labelEl && labelEl.textContent.trim() === labelText) {
            const valueEl = block.querySelector('.mon-stat-block__attribute-data-value');
            const extraEl = block.querySelector('.mon-stat-block__attribute-data-extra');
            return {
                label: labelEl.textContent.trim(),
                value: valueEl ? valueEl.textContent.trim() : '',
                extra: extraEl ? extraEl.textContent.trim() : ''
            };
        }
    }
    return null;
}

function getTidBitJson(monsterHtml, labelText) {
    // Find all attribute blocks
    const blocks = monsterHtml.querySelectorAll('.mon-stat-block__tidbit');
    for (let block of blocks) {
        const label = block.querySelector('.mon-stat-block__tidbit-label').textContent;
        if (label && label.trim() === labelText) {
            const value = block.querySelector('.mon-stat-block__tidbit-data').textContent;
            return {
                label: label.trim(),
                value: normalizeAndTidyPunctuation(value),
                extra: ''
            };
        }
    }
    return null;
}

function getActionLikeElement(monsterHtml, labelText) {
    // Find all attribute blocks
    const blocks = monsterHtml.querySelectorAll('.mon-stat-block__description-block');

    for (let block of blocks) {
        const label = block.querySelector('.mon-stat-block__description-block-heading').textContent;
        if (label && label.trim() === labelText) {
            const actionContainer = block.querySelector('.mon-stat-block__description-block-content')
            const allP = actionContainer.querySelectorAll('p')

            let actions = []
            for ( let p of allP) {
                console.log(p)
                
                const title = p.querySelector('strong')?.textContent || p.textContent.split(": ")[0];
                console.log(title)
                
                p.querySelector('em')?.remove(); // remove the title so only the content is left

                let content = ''
                content = p.textContent;
                console.log('title, content')

                console.log(content)
                actions.push({name: title, desc: content})
            }
            return actions;
        }
    }
    return null;
}

function getAttrStatsJson(monsterHtml) {
    let stats = {
        STR: 0, DEX: 0,
        CON: 0,INT: 0,
        WIS: 0, CHA: 0
    }

    let saves = {
        STR: 0, DEX: 0,
        CON: 0, INT: 0,
        WIS: 0, CHA: 0
    }

    const blocks = monsterHtml.querySelectorAll('.ability-block__stat');
    for (let block of blocks) {
        const statType = block.querySelector('.ability-block__heading').textContent;
        const score = block.querySelector('.ability-block__score').textContent;
        const mod = block.querySelector('.ability-block__modifier').textContent;
        stats[statType] = score
    }

    console.log("before")

    const savingThrowsString = getTidBitJson(monsterHtml, 'Saving Throws').value
    console.log("savingThrowsString", savingThrowsString)
    let savingThrowsArr = savingThrowsString.replaceAll("\n", "").replaceAll("+", "").trim().split(", ")
    console.log("savingThrowsArr", savingThrowsArr)

    savingThrowsArr.forEach(st => {
        let stSplit = st.split(" ")
        let type = stSplit[0]
        let value = stSplit[1].trim()
        console.log("type", type)
        console.log("value", value)
        console.log("===")
        Object.keys(saves).forEach(saveType => {
            if(saveType === type) {
                saves[saveType] = value
            }
        })
    })

    console.log("SAVES", saves)
    //  INT 16, WIS 16, CHA 18

    return {
        "strength": stats.STR,"dexterity": stats.DEX,
        "constitution": stats.CON,"intelligence": stats.INT,
        "wisdom": stats.WIS, "charisma": stats.CHA,

        "strength_save": saves.STR,
        "dexterity_save": saves.DEX,
        "constitution_save": saves.CON,
        "intelligence_save": saves.INT,
        "wisdom_save": saves.WIS,
        "charisma_save": saves.CHA,
    }
}

export const HtmlToDmBMapper = (htmlString) => {
    const monsterHtml = document.createElement('div');
    monsterHtml.innerHTML = htmlString;

    function innerHtml(selector) {
        const el = monsterHtml.querySelector(selector);
        if(el) {
            el.innerHTML = el.innerHTML.replaceAll("\n", " ").trim()
            return el.innerHTML;
        } else {
            return null;
        }
    }
    
    // const lvlObjsArray = Object.entries(levelData);
    // const lvlKeys = Object.keys(levelData);
    // let lvlObj = lvlObjsArray[monsterRes.challengeRatingId-2] || undefined
    // let profBonus = lvlObj ? lvlObj[1].profBonus : 0 
    const stats = getAttrStatsJson(monsterHtml)
    console.log(stats)
    let hpJson = getAttrJson(monsterHtml, "Hit Points");
    let speedJson = calcSpeed(getAttrJson(monsterHtml, "Speed"));
    let acJson = getAttrJson(monsterHtml, "Armor Class");
    let typeInfo = innerHtml("div.mon-stat-block__meta");

    let monsterObj = {
        "name": innerHtml("a.mon-stat-block__name-link"),
        "name_default": innerHtml("a.mon-stat-block__name-link"),
        "from": "dnd_b",
        "creatureGuid": generateUniqueId(),
        "status": 200,
        // "dnd_b_monster_id": monsterRes.id, // check if int or string, not sure i care about this
        "link": "https://www.dndbeyond.com" + getAttr(monsterHtml, 'a.mon-stat-block__name-link', 'href'),
        "avatarUrl": getAttr(monsterHtml, 'img.monster-image', 'src'),
        "hit_points": hpJson?.value,
        "hit_points_default": hpJson?.value,
        "hit_points_current": hpJson?.value,
        "hit_points_temp": 0,
        "hit_points_override": 0, 
        "hit_points_modifier": 0, 
        "hit_dice": hpJson?.extra,
        "hit_points_formula": hpJson?.extra, // double check
        "armor_class": acJson?.value,
        "armor_desc": acJson?.extra,  // double check
        "speed": speedJson,
        "initiative": 0,
        "last_damage": null,
        "alignment": "enemy",
        "groupGuid": null,
        "type": "monster",
        "border": COLOR_RED,
        "effects": [],
        "creature_type": findOptions(typeInfo, creatureTypes), // i.e. Fiend (Devil) - devil is missing
        "creature_alignment": findOptions(typeInfo, alignmentOptions),
        "size": findOptions(typeInfo, creatureSizes),
        "inspiration": false,
        "inventory": [],
        "hidden": true,
        "death_saves_failure_count": 0,
        "death_saves_success_count": 0,
        ...stats,
        "dnd_b_player_id": null,
        "senses": getTidBitJson(monsterHtml, "Senses").value,
        "languages": getTidBitJson(monsterHtml, "Languages").value,
        "cr": getTidBitJson(monsterHtml, "Challenge").value,
        "challenge_rating": getTidBitJson(monsterHtml, "Challenge").value,
        "damage_resistances": getTidBitJson(monsterHtml, "Damage Resistances")?.value,
        "damage_vulnerabilities": getTidBitJson(monsterHtml, "Damage Vulnerabilities")?.value,
        "damage_immunities": getTidBitJson(monsterHtml, "Damage Immunities")?.value,
        "condition_immunities": getTidBitJson(monsterHtml, "Condition Immunities")?.value,

        // need to add proficiency bonus with these
        "special_abilities": getActionLikeElement(monsterHtml, "Traits"),
        "actions": getActionLikeElement(monsterHtml, "Actions"),
        "bonus_actions": getActionLikeElement(monsterHtml, "Bonus Actions"), // double check
        "reactions": getActionLikeElement(monsterHtml, "Reactions"), // double check
        "legendary_actions": getActionLikeElement(monsterHtml, "Legendary Actions"), 
    }

    console.log(monsterObj)
    return monsterObj;
    // not done 
    // encounterGuid 
    // "subtype": capsFirstLetter(monster.type?.tags?.join(",") || '--'),
    // "skills"
    // "spellcasting": calcSpellCasting(monster?.spellcasting),
    // "legendary_desc": monster?.legendary?.length ? (monster?.legendaryHeader?.join(" ") || legendaryDescDefault(monster.name)) : "",
    //  "mythic_actions": addRechargeCount(calcActionTypes(object?.mythic) || null),
    //     "mythic_desc": object?.mythicHeader ? object?.mythicHeader : null,
    // "lair_actions": lair_actions, 
    // "regional_effects": regional_effects, 
    // "environments": '',
    // "sourceShort": monster?.source,
    // "page": monster?.page,
};

export default HtmlToDmBMapper;